import { render, staticRenderFns } from "./SidFonSize.vue?vue&type=template&id=31300616"
import script from "./SidFonSize.vue?vue&type=script&lang=js"
export * from "./SidFonSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports